import React, { useState, useEffect } from 'react';
import { BarChart3, Save } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function AnalyticsSettings() {
  const [form, setForm] = useState({ enabled: false, ga_id: '', gtm_id: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/settings/analytics')
      .then(r => setForm({
        enabled: r.data.enabled === true || r.data.enabled === 'true' || r.data.enabled === 'True',
        ga_id: r.data.ga_id || '',
        gtm_id: r.data.gtm_id || '',
      }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/settings/analytics', form);
      toast.success('Analytics ayarları kaydedildi');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Kaydetme hatası');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-10"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>;
  }

  return (
    <div data-testid="admin-analytics-settings" className="max-w-2xl">
      <div className="flex items-center gap-3 mb-2">
        <BarChart3 className="w-6 h-6 text-[hsl(var(--gold))]" />
        <h1 className="font-heading text-2xl font-semibold">Analytics / Takip Kodları</h1>
      </div>
      <p className="text-sm text-muted-foreground mb-6">
        Google Analytics (GA4) veya Google Tag Manager kodlarınızı girin. Ziyaretçi istatistiklerini kendi Google hesabınızdan takip edebilirsiniz.
      </p>

      <div className="p-6 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)] space-y-5">
        {/* Enabled toggle */}
        <label className="flex items-center justify-between cursor-pointer" data-testid="analytics-enabled-toggle">
          <div>
            <div className="text-sm font-medium">Takip Kodlarını Etkinleştir</div>
            <div className="text-xs text-muted-foreground">Kapalıyken siteye hiçbir takip kodu yüklenmez.</div>
          </div>
          <button
            type="button"
            onClick={() => setForm(f => ({ ...f, enabled: !f.enabled }))}
            className={`relative w-11 h-6 rounded-full transition-colors duration-200 ${form.enabled ? 'bg-[hsl(var(--gold))]' : 'bg-secondary'}`}
          >
            <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white transition-transform duration-200 ${form.enabled ? 'translate-x-5' : ''}`} />
          </button>
        </label>

        <div>
          <label className="block text-sm font-medium mb-1.5">Google Analytics (GA4) Ölçüm Kimliği</label>
          <input
            type="text"
            value={form.ga_id}
            onChange={e => setForm(f => ({ ...f, ga_id: e.target.value.trim() }))}
            placeholder="G-XXXXXXXXXX"
            className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))]"
            data-testid="analytics-ga-input"
          />
          <p className="text-xs text-muted-foreground mt-1">Örnek: G-ABC123DEF4</p>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">Google Tag Manager Kimliği</label>
          <input
            type="text"
            value={form.gtm_id}
            onChange={e => setForm(f => ({ ...f, gtm_id: e.target.value.trim() }))}
            placeholder="GTM-XXXXXXX"
            className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))]"
            data-testid="analytics-gtm-input"
          />
          <p className="text-xs text-muted-foreground mt-1">Örnek: GTM-ABC1234 (opsiyonel)</p>
        </div>

        <button
          onClick={handleSave}
          disabled={saving}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors disabled:opacity-50"
          data-testid="analytics-save-button"
        >
          {saving ? <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" /> : <Save className="w-4 h-4" />}
          Kaydet
        </button>
      </div>
    </div>
  );
}
